import React from "react";
import { s } from "../styles";

export default function Flag() {
  return (
    <span style={s.flag}>
      <span style={s.flagLeaf}>{"\uD83C\uDF41"}</span>
    </span>
  );
}